import { EntityDoc } from "../../entity/EntityDoc";

export class DtoDocsPostRes extends EntityDoc {}
